import { actions } from '.';

export function getServicesSucceed(payload) {
  return {
    type: actions.GET_SERVICES_SUCCEED,
    payload
  };
}

export function getServicesFailure(payload) {
  return {
    type: actions.GET_SERVICES_FAILURE,
    payload
  };
}

export function createServiceSucceed(payload) {
  return {
    type: actions.CREATE_SERVICE_SUCCEED,
    payload
  };
}

export function updateServiceSucceed(payload) {
  return {
    type: actions.UPDATE_SERVICE_SUCCEED,
    payload
  };
}

export function deleteServiceSucceed(payload) {
  return {
    type: actions.DELETE_SERVICE_SUCCEED,
    payload
  };
}
